import { Anime } from '../types/anime';

/**
 * Initial Anime Database
 * Total: 7 anime
 * Updated at: 2026-10-24T17:44:28.223Z
 */
export const INITIAL_ANIME_LIST: Anime[] = [
  {
    "id": "ANIME_1792304632999_eq0i",
    "title": "Black Clover Season 2",
    "thaiTitle": "แบล็คโคลเวอร์ ภาคที่ 2",
    "grade": "A",
    "season": "FALL",
    "year": 2026,
    "watchedEp": 0,
    "latestEp": 3,
    "totalEp": 26,
    "imageUrl": "https://anime-waku.com/wp-content/uploads/2026/10/nJuX6eauBhxWHDdalooZMNKBXTB.jpg",
    "status": "กำลังฉาย",
    "audioType": "ซับไทย",
    "broadcastDay": "SAT",
    "broadcastTime": "22:00",
    "notifyLine": true,
    "order": 1,
    "sources": [
      {
        "type": "anime-waku",
        "name": "Anime-Waku",
        "url": "https://anime-waku.com/anime/black-clover-season-2/",
        "latestEp": 3
      },
      {
        "type": "bilibili",
        "name": "Bilibili",
        "url": "https://www.bilibili.tv/th/play/2432940",
        "latestEp": 3
      }
    ],
    "synopsis": "ในอดีตมนุษย์นั้นเกือบถูกเทพอสูรฆ่าล้างเผ่าพันธุ์ แต่ได้รับการช่วยเหลือจากจอมเวท ซึ่งได้ถูกเรียกว่า จักรพรรดิเวทมนตร์แล้วก่อตั้งอาณาจักรโครเวอร์ขึ้นมา ว่ากันว่า จอมเวทที่เก่งกาจสุดจะเป็นจักรพรรดิเวทมนตร์คนต่อไป เวลาผ่านไป แอสต้าและยูโน สองเด็กกำพร้าที่เกิดในโบสถ์นอกอาณาจักรโคลเวอร์ได้เติบโตขึ้น ตัวแอสต้าไม่มีเวทมนตร์แต่ฝันที่จะได้เป็นจักรพรรดิเวทมนตร์ จึงฝึกด้านการต่อสู้ด้วยกำลัง ในขณะที่ยูโนมีความสามารถที่ยอดเยี่ยม ทั้งสองแข่งกันว่าใครจะได้เป็นอัศวินเวทที่ยอดเยี่ยมที่สุดในอาณาจักร จึงออกเดินทางผจญภัยกัน",
    "detectedDayNote": "อัปเดตล่าสุด: วันเสาร์ (17 ต.ค. 2569) เวลา 22:45 น.",
    "episodes": [
      {
        "number": 1,
        "title": "บทที่1 - เปิดศึก",
        "url": "https://www.bilibili.tv/th/play/2432940/31524599",
        "audio": "ซับไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/22935906d0fb72ec2c7f4d622c3dccdc.png",
        "vipBadge": "",
        "publishTime": "2026-10-03T23:00:00+08:00"
      },
      {
        "number": 2,
        "title": "บทที่2 - ประตูสู่ขุมนรก",
        "url": "https://www.bilibili.tv/th/play/2432940/31524678",
        "audio": "ซับไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/1bd37f503274aa01327eb9875e88a85e.png",
        "vipBadge": "",
        "publishTime": "2026-10-10T23:00:00+08:00"
      },
      {
        "number": 3,
        "title": "บทที่3 - ผู้พิทักษ์สีดำ",
        "url": "https://www.bilibili.tv/th/play/2432940/31524747",
        "audio": "ซับไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/dc1b7b4518ccca7d323456eb0e0ad1ed.png",
        "vipBadge": "พรีเมียม",
        "publishTime": "2026-10-17T23:00:00+08:00"
      }
    ],
    "linksCheckedAt": 1792863868219,
    "score": "8.81",
    "lastNotifiedEp": 3
  },
  {
    "id": "ANIME_1792307903557_98r2",
    "title": "So What’s Wrong with getting Reborn as a Goblin?",
    "thaiTitle": "เกิดใหม่เป็นก็อบลินแล้วไง มีคำถามอะไรไหม?",
    "grade": "A",
    "season": "FALL",
    "year": 2026,
    "watchedEp": 0,
    "latestEp": 4,
    "totalEp": 12,
    "imageUrl": "https://cdn.myanimelist.net/images/anime/1760/159941l.jpg",
    "status": "กำลังฉาย",
    "audioType": "ซับไทย",
    "broadcastDay": "MON",
    "broadcastTime": "20:00",
    "notifyLine": true,
    "order": 2,
    "sources": [
      {
        "type": "youtube",
        "name": "Ani-One",
        "url": "https://www.youtube.com/playlist?list=PLasf6e7Vb3mE",
        "latestEp": 4
      },
      {
        "type": "bilibili",
        "name": "Bilibili",
        "url": "https://www.bilibili.tv/th/play/2433441",
        "latestEp": 4
      },
      {
        "type": "anime-waku",
        "name": "Anime-Waku",
        "url": "https://anime-waku.com/anime/tensei-goblin-dakedo-shitsumon-aru/",
        "latestEp": 4
      }
    ],
    "synopsis": "ตอนใหม่ ทุกวันจันทร์ เวลา 20:00 น. ดูตอนอื่นๆได้ที่ https://www.youtube.com/playlist?list=PLasf6e7Vb3mE อนิเมะ ซับไทย So What’s Wrong with getting Reborn as a Goblin? | เกิดใหม่เป็นก็อบลินแล้วไง มีคำถามอะไรไหม? ถูกลิขสิทธิ์ ติดตามเราได้ที่ช่องทางต่าง ๆ ดังนี้ FB: https://www.facebook.com/AniOneThailand TW: https://twitter.com/AniOneThailand",
    "detectedDayNote": "ตอนใหม่ทุกวันจันทร์ เวลา 20:00 น. (Ani-One)",
    "episodes": [],
    "linksCheckedAt": 1792863868219,
    "lastNotifiedEp": 4
  },
  {
    "id": "ANIME_1792310600337_uvdk",
    "title": "Romelia Senki",
    "thaiTitle": "บันทึกสงครามโรเมเลีย",
    "grade": "A",
    "season": "FALL",
    "year": 2026,
    "watchedEp": 0,
    "latestEp": 3,
    "totalEp": 12,
    "imageUrl": "https://anime-waku.com/wp-content/uploads/2026/10/xOhx5KpSAlrEbqsu9TaCdmdIb72.jpg",
    "status": "กำลังฉาย",
    "audioType": "ซับไทย",
    "broadcastDay": "UNKNOWN",
    "broadcastTime": "",
    "notifyLine": true,
    "order": 3,
    "sources": [
      {
        "type": "anime-waku",
        "name": "Anime-Waku",
        "url": "https://anime-waku.com/anime/romelia-senki/",
        "latestEp": 3
      }
    ],
    "detectedDayNote": "เพิ่มจากหน้าสำรวจ",
    "linksCheckedAt": 1792863868219,
    "synopsis": "",
    "episodes": [],
    "lastNotifiedEp": 3
  },
  {
    "id": "ANIME_1792310616746_1f2w",
    "title": "Tokyo Revengers Santen Sensou-hen",
    "thaiTitle": "โตเกียว รีเวนเจอร์ส (ภาค4)",
    "grade": "A",
    "season": "FALL",
    "year": 2026,
    "watchedEp": 0,
    "latestEp": 3,
    "totalEp": 13,
    "imageUrl": "https://anime-waku.com/wp-content/uploads/2026/10/y76Q9XQw0UaFjwJlreOA5Pewl8y.jpg",
    "status": "กำลังฉาย",
    "audioType": "ซับ+พากย์",
    "broadcastDay": "UNKNOWN",
    "broadcastTime": "",
    "notifyLine": true,
    "order": 4,
    "sources": [
      {
        "type": "anime-waku",
        "name": "Anime-Waku",
        "url": "https://anime-waku.com/anime/tokyo-revengers-santen-sensou-hen/",
        "latestEp": 3
      }
    ],
    "detectedDayNote": "เพิ่มจากหน้าสำรวจ",
    "linksCheckedAt": 1792863868219,
    "synopsis": "",
    "episodes": [],
    "lastNotifiedEp": 3
  },
  {
    "id": "ANIME_1792310635360_nnrz",
    "title": "Re:ZERO รีเซทชีวิต ฝ่าวิกฤตต่างโลก ซีซั่น 4 (พากย์ไทย)",
    "thaiTitle": "รีเซทชีวิต ฝ่าวิกฤตต่างโลก (ภาค4)",
    "grade": "A",
    "season": "SPRING",
    "year": 2026,
    "watchedEp": 0,
    "latestEp": 14,
    "totalEp": 16,
    "imageUrl": "https://pic.bstarstatic.com/ogv/53740db1d625f8557895bc9060cc6361.png",
    "status": "กำลังฉาย",
    "audioType": "ซับ+พากย์",
    "broadcastDay": "WED",
    "broadcastTime": "20:00",
    "notifyLine": true,
    "order": 5,
    "sources": [
      {
        "type": "bilibili",
        "name": "Bilibili",
        "url": "https://www.bilibili.tv/th/play/2408024",
        "latestEp": 14
      },
      {
        "type": "anime-waku",
        "name": "Anime-Waku",
        "url": "https://anime-waku.com/anime/rezero-ss4-th/",
        "latestEp": 13
      }
    ],
    "detectedDayNote": "ตอนใหม่ทุกวันพุธ เวลา 20:00 น. (Bilibili)",
    "linksCheckedAt": 1792863868219,
    "synopsis": "พวกสุบารุซึ่งผ่านการต่อสู้เสี่ยงเป็นเสี่ยงตายในเมืองประตูน้ำพริสเทล่ามาได้ ทว่าสิ่งที่ต้องแลกเปลี่ยนกับมันกลับเป็นสิ่งที่ยิ่งใหญ่เกินไป เพราะอำนาจของ “ตะกละ” เรมซึ่งต้องหลับใหล ครูชถูกแย่งชิงความทรงจำ ท้ายที่สุดยูเรียสที่ถูกแย่งนามไป\nในขณะที่กำลังตามหาหนทางในการช่วยพวกเขา สุบารุได้รู้เข้าถึงตัวตนของ “นักปราชญ์” ที่ว่ากันว่ามองทะลุในทุกสรรพสิ่ง และมีความรู้ในทุกศาสตร์ความรู้อยู่\nเป้าหมายต่อไปคือ “หอคอยสังเกตการณ์เพลเดส” ซึ่งนักปราชญ์อาศัยอยู่ ที่แห่งนั้นตั้งตระหง่านอยู่ในมหาทะเลทราย “เนินทรายอาวเกลีย” ซึ่งแม้แต่ “เซียนดาบ” ไรน์ฮาร์ด ยังไม่สามารถพิชิตมันได้\nท่ามกลางธรรมชาติอันบ้าคลั่ง อสูรร้ายที่ไม่รู้จัก และภัยอันตรายที่ไม่อาจจินตนาการได้รอคอยอยู่ เพื่อนำทุกอย่างกลับคืนมาด้วยกันกับพวกพ้อง การเดินทางอันเดิมพันชีวิตของเด็กหนุ่มได้เริ่มต้นขึ้นแล้ว—",
    "episodes": [
      {
        "number": 1,
        "title": "บทที่1",
        "url": "https://www.bilibili.tv/th/play/2408024/30585991",
        "audio": "พากย์ไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/32d2a4db1eff434afe6fb35722c8db6c.png",
        "vipBadge": "",
        "publishTime": "2026-06-03T21:00:00+08:00"
      },
      {
        "number": 2,
        "title": "บทที่2",
        "url": "https://www.bilibili.tv/th/play/2408024/30586074",
        "audio": "พากย์ไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/ea0378f4af98e1c4840fea9f3eab76bf.png",
        "vipBadge": "",
        "publishTime": "2026-06-10T21:00:00+08:00"
      },
      {
        "number": 3,
        "title": "บทที่3",
        "url": "https://www.bilibili.tv/th/play/2408024/30586130",
        "audio": "พากย์ไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/527e48372a1e1cdf5f57f61c057b9cd9.png",
        "vipBadge": "",
        "publishTime": "2026-06-17T21:00:00+08:00"
      },
      {
        "number": 4,
        "title": "บทที่4",
        "url": "https://www.bilibili.tv/th/play/2408024/30586228",
        "audio": "พากย์ไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/22e212343469c3b7b9ae07cf955ce62e.png",
        "vipBadge": "",
        "publishTime": "2026-06-24T21:00:00+08:00"
      },
      {
        "number": 5,
        "title": "บทที่5",
        "url": "https://www.bilibili.tv/th/play/2408024/30586307",
        "audio": "พากย์ไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/b36e40536aefca34799ce552ef3768d7.png",
        "vipBadge": "",
        "publishTime": "2026-07-01T21:00:00+08:00"
      },
      {
        "number": 6,
        "title": "บทที่6",
        "url": "https://www.bilibili.tv/th/play/2408024/30586431",
        "audio": "พากย์ไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/a22d9188691569c0a6b1cf255ebcdd17.png",
        "vipBadge": "",
        "publishTime": "2026-07-08T21:00:00+08:00"
      },
      {
        "number": 7,
        "title": "บทที่7",
        "url": "https://www.bilibili.tv/th/play/2408024/30586551",
        "audio": "พากย์ไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/4f4d57821b6b449a49588dd9d0455c1a.png",
        "vipBadge": "",
        "publishTime": "2026-07-15T21:00:00+08:00"
      },
      {
        "number": 8,
        "title": "บทที่8",
        "url": "https://www.bilibili.tv/th/play/2408024/30586646",
        "audio": "พากย์ไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/3ad909218f38449a265e155a947ff6f4.png",
        "vipBadge": "",
        "publishTime": "2026-07-22T21:00:00+08:00"
      },
      {
        "number": 9,
        "title": "บทที่9",
        "url": "https://www.bilibili.tv/th/play/2408024/30586775",
        "audio": "พากย์ไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/b00a1fda0a9d8fcfb8220e5f8cd8d04b.png",
        "vipBadge": "",
        "publishTime": "2026-07-29T21:00:00+08:00"
      },
      {
        "number": 10,
        "title": "บทที่10",
        "url": "https://www.bilibili.tv/th/play/2408024/30586833",
        "audio": "พากย์ไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/b86ee7fcb835fd9da0f29dc7f8bfb5db.png",
        "vipBadge": "",
        "publishTime": "2026-08-05T21:00:00+08:00"
      },
      {
        "number": 11,
        "title": "บทที่11",
        "url": "https://www.bilibili.tv/th/play/2408024/30586941",
        "audio": "พากย์ไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/f335fbfeb7ddcc4c7dea3bda46fb5db0.png",
        "vipBadge": "",
        "publishTime": "2026-08-12T21:00:00+08:00"
      },
      {
        "number": 12,
        "title": "บทที่12",
        "url": "https://www.bilibili.tv/th/play/2408024/30586997",
        "audio": "พากย์ไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/e8988bb79962c7ac8ce54494472c5a34.png",
        "vipBadge": "",
        "publishTime": "2026-10-07T21:00:00+08:00"
      },
      {
        "number": 13,
        "title": "บทที่13",
        "url": "https://www.bilibili.tv/th/play/2408024/30587100",
        "audio": "พากย์ไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/60fac8d6829816057fc9631055cc6078.png",
        "vipBadge": "",
        "publishTime": "2026-10-14T21:00:00+08:00"
      },
      {
        "number": 14,
        "title": "บทที่14",
        "url": "https://www.bilibili.tv/th/play/2408024/30587241",
        "audio": "พากย์ไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/fb066583b771a92a319641292421c788.png",
        "vipBadge": "",
        "publishTime": "2026-10-21T21:00:00+08:00"
      }
    ],
    "lastUpdatedAt": "2026-10-22",
    "lastNotifiedEp": 14
  },
  {
    "id": "ANIME_1792310636447_sn7z",
    "title": "ซวยเหลือหลายเกิดใหม่กลายเป็นดาบ ภาคที่ 2",
    "thaiTitle": "ซวยเหลือหลายเกิดใหม่กลายเป็นดาบ (ภาค2)",
    "grade": "A",
    "season": "FALL",
    "year": 2026,
    "watchedEp": 0,
    "latestEp": 4,
    "totalEp": 12,
    "imageUrl": "https://pic.bstarstatic.com/ogv/89be2d778c99b9abed3e0cdef0db30d6.png",
    "status": "กำลังฉาย",
    "audioType": "ซับไทย",
    "broadcastDay": "WED",
    "broadcastTime": "22:30",
    "notifyLine": true,
    "order": 6,
    "sources": [
      {
        "type": "bilibili",
        "name": "Bilibili",
        "url": "https://www.bilibili.tv/th/play/2432099",
        "latestEp": 4
      },
      {
        "type": "anime-waku",
        "name": "Anime-Waku",
        "url": "https://anime-waku.com/anime/tensei-shitara-ken-deshita-ii/",
        "latestEp": 3
      }
    ],
    "detectedDayNote": "ตอนใหม่ทุกวันพุธ เวลา 22:30 น. (Bilibili)",
    "linksCheckedAt": 1792863868219,
    "synopsis": "ฟราน เด็กสาวเผ่าแมวดำผู้เคยถูกกดขี่ในฐานะทาส “ไร้นาม” ได้พบกับ “อาจารย์” ดาบสติปัญญาที่กลายมาเป็นอาวุธคู่ใจ \nหลังร่วมมือกันทำเควสต์จนสร้างชื่อเสียงในกิลด์นักผจญภัยแห่งเมืองป้อมปราการอเลซซ่า ทั้งสองได้ออกเดินทางต่อมุ่งหน้าสู่ “เมืองท่าดาส” เพื่อไขว่คว้าเป้าหมายในการ “วิวัฒนาการ” และทำความปรารถนาของฟรานให้เป็นจริง\n\nทว่าระหว่างทาง พวกเขาได้พบกับเกาะลอยฟ้าปริศนา และได้เจอกับ “ฌาน ดูบี้” จอมเวทเนโครแมนเซอร์ผู้ตั้งเป้าพิชิตเกาะแห่งนี้ \nเมื่อตกปากรับคำท้าทายและก้าวเข้าสู่เขาวงกตลอยฟ้าอันเลวร้ายที่เต็มไปด้วยฝูงสัตว์อสูรวิญญาณมรณา บทพิสูจน์บทใหม่ของการผจญภัยระหว่างสาวน้อยหูแมวและดาบขี้ห่วงจึงได้เปิดฉากขึ้น!",
    "episodes": [
      {
        "number": 1,
        "title": "บทที่1 - สิ่งที่ลอยอยู่บนฟ้าคือเกาะนั่นเอง",
        "url": "https://www.bilibili.tv/th/play/2432099/31523556",
        "audio": "ซับไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/daa737a5f196b25adec301a4ad3e6bc9.png",
        "vipBadge": "",
        "publishTime": "2026-09-30T23:30:00+08:00"
      },
      {
        "number": 2,
        "title": "บทที่2 - ฌาน ดูบี้ ฝีมือดีมากเลย",
        "url": "https://www.bilibili.tv/th/play/2432099/31523632",
        "audio": "ซับไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/b11c58829c6d0b93c613ac2af96d3023.png",
        "vipBadge": "",
        "publishTime": "2026-10-07T23:30:00+08:00"
      },
      {
        "number": 3,
        "title": "บทที่3 - อันเดดแข็งมากเลย",
        "url": "https://www.bilibili.tv/th/play/2432099/31523735",
        "audio": "ซับไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/43681b60a5bc9ab0e8a98a66ac7a95eb.png",
        "vipBadge": "",
        "publishTime": "2026-10-14T23:30:00+08:00"
      },
      {
        "number": 4,
        "title": "บทที่4 - ราชันแห่งวิญญาณมรณะชวนสิ้นหวังมาก",
        "url": "https://www.bilibili.tv/th/play/2432099/31523830",
        "audio": "ซับไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/a7fdbcde75a0dbe6893ddde222a5508e.png",
        "vipBadge": "พรีเมียม",
        "publishTime": "2026-10-21T23:30:00+08:00"
      }
    ],
    "lastUpdatedAt": "2026-10-22",
    "lastNotifiedEp": 4
  },
  {
    "id": "ANIME_1792310639553_lxgs",
    "title": "วิวาห์แห่งหิ่งห้อย",
    "thaiTitle": "วิวาห์แห่งหิ่งห้อย",
    "grade": "A",
    "season": "FALL",
    "year": 2026,
    "watchedEp": 0,
    "latestEp": 2,
    "totalEp": 12,
    "imageUrl": "https://pic.bstarstatic.com/ogv/0873a1f617ffb8a93d061f26f8120eac.png",
    "status": "กำลังฉาย",
    "audioType": "ซับไทย",
    "broadcastDay": "FRI",
    "broadcastTime": "23:00",
    "notifyLine": true,
    "order": 7,
    "sources": [
      {
        "type": "bilibili",
        "name": "Bilibili",
        "url": "https://www.bilibili.tv/th/play/2432745",
        "latestEp": 2
      },
      {
        "type": "anime-waku",
        "name": "Anime-Waku",
        "url": "https://anime-waku.com/anime/hotaru-no-yomeiri/",
        "latestEp": 2
      }
    ],
    "detectedDayNote": "ตอนใหม่ทุกวันศุกร์ เวลา 23:00 น. (Bilibili)",
    "linksCheckedAt": 1792863868219,
    "synopsis": "เรื่องราวความรักระหว่างคุณหนูผู้สูงศักดิ์ที่มีชีวิตเหลืออีกไม่นาน กับนักฆ่าผู้ทุ่มเทความรักอย่างสุดหัวใจ\nซาโตโกะ คิริกายะ คุณหนูแห่งตระกูลขุนนางผู้งดงาม เกิดมาพร้อมทุกสิ่งที่ใครหลายคนใฝ่ฝัน แต่กลับต้องเผชิญกับชะตากรรมที่ไม่มีวันยืนยาว ความปรารถนาของเธอคือการแต่งงานกับตระกูลชั้นสูง เพื่อเป็นความภาคภูมิใจของบิดา\nทว่าในคืนหนึ่ง ชีวิตของเธอกลับเปลี่ยนไป เมื่อเธอถูกพาตัวไปและตกอยู่ในสถานการณ์อันตราย ที่นั่นเธอได้พบกับชินเป นักฆ่าผู้เชื่อว่าเธอคือ “คู่แห่งโชคชะตา”\nจากคำโกหกเพียงชั่วครู่ กลับกลายเป็นสายสัมพันธ์ที่ไม่อาจตัดขาด เมื่อความรักอันรุนแรงของเขา และความรู้สึกที่ซาโตโกะพยายามซ่อนไว้ ต้องเผชิญกับโชคชะตาที่ไม่อาจหลีกหนี",
    "episodes": [
      {
        "number": 1,
        "title": "บทที่1 - การตอบแทนที่มิได้ปรารถนา",
        "url": "https://www.bilibili.tv/th/play/2432745/31509889",
        "audio": "ซับไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/3e2b1010071a77fdc53dc31ea445bed0.png",
        "vipBadge": "",
        "publishTime": "2026-10-10T00:00:00+08:00"
      },
      {
        "number": 2,
        "title": "บทที่2 - เกาะนางสวรรค์",
        "url": "https://www.bilibili.tv/th/play/2432745/31509993",
        "audio": "ซับไทย",
        "thumbnail": "https://pic.bstarstatic.com/ogv/dff48daa1159b261c67b9b579cdbdabd.png",
        "vipBadge": "",
        "publishTime": "2026-10-17T00:00:00+08:00"
      }
    ],
    "lastNotifiedEp": 2
  }
];
